import { GalleryItemType, ImgAndPromptItemType } from "@/stores/gallery";
import { makeAutoObservable } from "mobx";

interface GalleryDataType {
  list: GalleryItemType[];
  counter: number;
  page_size: number;
  page_index: number;
  sort: string;
  // author: string;
}
class EditorGalleryStore {
  imgAndPromptList: ImgAndPromptItemType[] = [];
  galleryData: GalleryDataType = {
    list: [],
    counter: 0,
    page_size: 40,
    page_index: 1,
    sort: "sort_default",
  };
  loading = false;
  empty = false;
  wordCheckState = false;
  keywords = "";

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  setKeywords = (value: string) => {
    this.keywords = value ?? "";
  };

  setImgAndPromptList(imgAndPromptList: ImgAndPromptItemType[]) {
    this.imgAndPromptList = imgAndPromptList;
  }
  setGalleryData(payload: GalleryDataType) {
    this.galleryData = payload;
  }
  setLoading(payload: boolean) {
    this.loading = payload;
  }
  setEmpty(payload: boolean) {
    this.empty = payload;
  }
  setWordCheckState(payload: boolean) {
    this.wordCheckState = payload;
  }
}

export const editorGalleryStore = new EditorGalleryStore();
